import { IProduct } from "@faire/web-api/indigofair/data/IProduct";
import { IProductOption } from "@faire/web-api/indigofair/data/IProductOption";

import { PerStyleVariationMapBuilder } from "@faire/retailer/features/OpenSizing/PerStyleVariationMapBuilder";

export const isDiscontinued = (
  product: Pick<IProduct, "state">,
  selectedOption: undefined | IProductOption
): boolean =>
  selectedOption === undefined ||
  selectedOption.state === IProduct.State.NOT_FOR_SALE ||
  product.state === IProduct.State.NOT_FOR_SALE;

export const isProductOptionInStock = (
  productOption: IProductOption,
  perStyleOptionVariations?: PerStyleVariationMapBuilder.IPerStyleOptionVariation[]
) => {
  if (perStyleOptionVariations) {
    return perStyleOptionVariations.some(
      (variation) => variation.inventory > 0
    );
  }

  return productOption.state === IProduct.State.FOR_SALE;
};
